// src/components/project-card.tsx
"use client";

import Image from "next/image";

export interface ProjectCardProps {
  img: string;
  title: string;
  desc: string;
  href: string;
}

export default function ProjectCard({ img, title, desc, href }: ProjectCardProps) {
  const isReady = Boolean(href && href.length > 0);

  return (
    <div className="bg-transparent">
      <div className="mx-0 mt-0 mb-6 h-80 overflow-hidden rounded-lg">
        <Image
          src={img}
          alt={title}
          width={768}
          height={768}
          className="h-full w-full object-cover"
        />
      </div>

      <div className="p-0">
        {isReady ? (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-gray-900 hover:text-gray-800"
          >
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
          </a>
        ) : (
          <h3 className="text-xl font-semibold mb-2">{title}</h3>
        )}

        <p className="mb-6 font-normal text-gray-500">{desc}</p>

        <button
          type="button"
          disabled={!isReady}
          onClick={() => {
            if (!isReady) return;
            window.open(href, "_blank", "noopener,noreferrer");
          }}
          className={`inline-flex items-center px-3 py-1.5 text-sm border rounded
            ${isReady ? "border-gray-400 text-gray-800" : "border-gray-300 text-gray-400 cursor-not-allowed"}
          `}
          aria-label={isReady ? `Watch ${title}` : "Coming soon"}
        >
          {isReady ? "Watch now" : "Soon"}
        </button>
      </div>
    </div>
  );
}